import {
  createOrUpdateAffordaPortalForms,
  deleteAffordaPortalForm,
} from 'services/affordaPortalForms';
import {
  getPrimaryFormData,
  getSecondaryFormData,
  savePrimaryFormData,
  saveSecondaryFormData,
  saveShortFormData,
} from 'services/formService';
import { updateAffordaDetails } from 'services/affordableService';
import { postWagesAndIncome } from 'services/affordaWagesAndIncomeService';
import { postAssets } from 'services/affordaAssetsService';
import { postDeductions } from 'services/affordaDeductionsService';
import { getPrimaryFormPayload } from 'hooks/mutations/useSavePrimaryFormMutation.utils';
import { getSecondaryFormPayload } from 'hooks/mutations/useSaveSecondaryFormMutation.utils';
import { updateContactPreferences } from 'services/communicationPreferencesService';
import { updateProspectPreferenceV2 } from 'services/prospectPreferenceService';

export const MUTATION_KEYS = {
  SAVE_FORM_STATE: 'SAVE_FORM_STATE',
  DELETE_FORM: 'DELETE_FORM',
  SAVE_SECTIONS_PROGRESS: 'SAVE_SECTIONS_PROGRESS',
  SAVE_WAGES_AND_INCOME: 'SAVE_WAGES_AND_INCOME',
  SAVE_ASSETS: 'SAVE_ASSETS',
  SAVE_DEDUCTIONS: 'SAVE_DEDUCTIONS',
  SAVE_SHORT_FORM: 'SAVE_SHORT_FORM',
  SAVE_PRIMARY_FORM: 'SAVE_PRIMARY_FORM',
  SAVE_SECONDARY_FORM: 'SAVE_SECONDARY_FORM',
  UPDATE_CONTACT_PREFERENCES: 'UPDATE_CONTACT_PREFERENCES',
  UPDATE_PROSPECT_PREFERENCES: 'UPDATE_PROSPECT_PREFERENCES',
};

export const mutationRegistry = {
  [MUTATION_KEYS.SAVE_FORM_STATE]: ({
    organizationId,
    propertyId,
    portalUserId,
    forms,
  }) =>
    createOrUpdateAffordaPortalForms({
      organizationId,
      propertyId,
      portalUserId,
      payload: forms,
    }),
  [MUTATION_KEYS.DELETE_FORM]: ({ organizationId, propertyId, portalUserId }) =>
    deleteAffordaPortalForm({ organizationId, propertyId, portalUserId }),
  [MUTATION_KEYS.SAVE_SECTIONS_PROGRESS]: ({
    organizationId,
    propertyId,
    affordaPortalDetailsId,
    requestData,
  }) =>
    updateAffordaDetails(
      organizationId,
      propertyId,
      affordaPortalDetailsId,
      requestData,
    ),
  [MUTATION_KEYS.SAVE_WAGES_AND_INCOME]: ({
    organizationId,
    propertyId,
    affordableQualificationId,
    applicantId,
    data,
  }) =>
    postWagesAndIncome(
      organizationId,
      propertyId,
      affordableQualificationId,
      applicantId,
      data,
    ),
  [MUTATION_KEYS.SAVE_ASSETS]: ({
    organizationId,
    propertyId,
    affordableQualificationId,
    applicantId,
    data,
  }) =>
    postAssets(
      organizationId,
      propertyId,
      affordableQualificationId,
      applicantId,
      data,
    ),
  [MUTATION_KEYS.SAVE_DEDUCTIONS]: ({
    organizationId,
    propertyId,
    affordableQualificationId,
    applicantId,
    data,
  }) =>
    postDeductions(
      organizationId,
      propertyId,
      affordableQualificationId,
      applicantId,
      data,
    ),
  [MUTATION_KEYS.SAVE_SHORT_FORM]: ({
    organizationId,
    propertyId,
    applicantId,
    payload,
  }) =>
    saveShortFormData({
      organizationId,
      propertyId,
      applicantId,
      payload,
    }),
  [MUTATION_KEYS.SAVE_PRIMARY_FORM]: async ({
    organizationId,
    propertyId,
    applicantId,
    update,
    states,
  }) => {
    const initialData = await getPrimaryFormData({
      organizationId,
      propertyId,
      applicantId,
    });
    const payload = getPrimaryFormPayload({ initialData, update, states });
    return savePrimaryFormData({
      organizationId,
      propertyId,
      applicantId,
      payload,
    });
  },
  [MUTATION_KEYS.SAVE_SECONDARY_FORM]: async ({
    organizationId,
    propertyId,
    applicantId,
    update,
    states,
  }) => {
    const initialData = await getSecondaryFormData({
      organizationId,
      propertyId,
      applicantId,
    });
    const payload = getSecondaryFormPayload({ initialData, update, states });
    return saveSecondaryFormData({
      organizationId,
      propertyId,
      applicantId,
      payload,
    });
  },
  [MUTATION_KEYS.UPDATE_CONTACT_PREFERENCES]: ({
    propertyId,
    contactId,
    preferences,
    modifiedBy,
  }) =>
    updateContactPreferences({
      propertyId,
      contactId,
      preferences,
      modifiedBy,
    }),
  [MUTATION_KEYS.UPDATE_PROSPECT_PREFERENCES]: ({
    organizationId,
    propertyId,
    householdProspectId,
    preferences,
  }) =>
    updateProspectPreferenceV2({
      organizationId,
      propertyId,
      prospectId: householdProspectId,
      partialProspectPreference: preferences,
    }),
};
